
function getContracts(contracts) {
  return contracts.map(contract => (
    (contract.contractId).toString()
  ));
}

export function getUpdateData(client, item) {
  const contracts = getContracts(item.user.contracts);
  return {
    hasUser: true,
    client: {
      name: client.sphereClient.name,
    },
    clientId: client.sphereClient.id,
    userId: item.userId,
    email: item.user.email,
    emailSeller: item.emailSeller,
    contracts,
    checked: contracts,
    fullName: item.user.name,
    approveId1: item.approveId1,
    approveId2: item.approveId2,
    permissions: {
      cart: item.cartPermission,
      sphere: item.spherePermission,
      email: item.emailPermission,
      spot: item.spotPermission,
      clientCode: item.clientCodePermission,
      price: item.pricePermission,
      crossSelling: item.crossSellingPermission,
      leadTime: item.leadTimePermission,
      stock: item.stockPermission,
      panel: item.panelPermission,
      similarity: item.similarityPermission,
      purchaseEstimate: item.purchaseEstimatePermission,
      purchaseBilling: item.purchaseBillingPermission,
      purchaseBankSlip: item.purchaseBankSlipPermission,
      purchaseBankSlipStock: item.purchaseBankSlipStockPermission,
      purchaseBankSlipMinDeliveryDate: item.purchaseBankSlipMinDeliveryDatePermission,
      purchaseDebit: item.purchaseDebitPermission,
      purchaseCredit: item.purchaseCreditPermission,
      purchaseCreditStock: item.purchaseCreditStockPermission,
      purchaseCreditMinDeliveryDate: item.purchaseCreditMinDeliveryDatePermission,
      purchasePaymentGateway: item.purchasePaymentGateway,
      purchase: item.purchasePermission,
      cartUsers: item.cartUsersPermission,
      opicCode: item.opicCodePermission,
      soneparCode: item.soneparCodePermission,
      visualizeAllOrders: item.visualizeAllOrdersPermission,
      managerEmail: item.managerEmailPermission,
      allowMixedPurchase: item.allowMixedPurchase,
    },
    limit: item.limit,
  };
}

export default {
  getUpdateData,
};
